import {Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {NgClass} from '@angular/common';
import {SpinnerComponent} from 'src/lib/components/spinner/spinner.component';
import {PopoverMessageComponent} from '../popover-message/popover-message.component';


@Component({
  selector: 'moti-button-extended',
  templateUrl: './button-extended.component.html',
  styleUrls: ['./button-extended.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgClass,
    SpinnerComponent,
    PopoverMessageComponent,
  ],
})
export class ButtonExtendedComponent implements OnInit, OnDestroy {
  @Input() styleClasses: string[] = [];
  @Input() isLoading: boolean = false;
  @Input() disabled: boolean = false;
  @Input() successTrigger$: Observable<boolean> = undefined;

  @Input() popoverText: string = '';
  @Input() popoverHtml: string = '';
  @Input() popoverDelay: number | [number, number];

  protected isSuccessful: boolean = false;

  private sub: Subscription;


  ngOnInit() {
    if (typeof this.popoverDelay === 'number') {
      // Make popover go away right away if "go-away time" not otherwise defined
      this.popoverDelay = [this.popoverDelay, 0];
    }

    if (this.successTrigger$) {
      this.sub = this.successTrigger$.subscribe({
        next: success => {
          this.isSuccessful = success;

          if (success) {
            setTimeout(() => {
              this.isSuccessful = false;
            }, 2500);
          }
        },
      });
    }
  }


  ngOnDestroy() {
    this.sub?.unsubscribe();
  }
}
